<!-- Desktop -->
<div class="hidden md:flex items-center">
  <button (click)="changeLang('es')"
    class="px-2 md:px-3 py-[34px] md:py-[37px] text-[#F2F4FE] text-sm font-normal tracking-widest hover:text-[#5173EF] transition"
    [ngClass]="{ 'text-[#5173EF]': currentLang === 'es' }">
    ES
  </button>
  <span class="text-white/50">|</span>
  <button (click)="changeLang('en')"
    class="px-2 md:px-3 py-[34px] md:py-[37px] text-[#F2F4FE] text-sm font-normal tracking-widest hover:text-[#5173EF] transition"
    [ngClass]="{ 'text-[#5173EF]': currentLang === 'en' }">
    EN
  </button>
</div>

<!-- Mobile -->
<div
  class="md:hidden nav-link-mobile block py-2 px-4 text-sm text-[#F2F4FE] hover:bg-white/10 focus:outline-none rounded transition duration-200">
  <div class="flex justify-start items-center space-x-2">
    <button (click)="changeLang('es')" class="text-sm font-normal tracking-widest hover:text-[#5173EF] transition"
      [ngClass]="{ 'text-[#5173EF]': currentLang === 'es' }">
      ES
    </button>
    <span class="text-white/50">|</span>
    <button (click)="changeLang('en')" class="text-sm font-normal tracking-widest hover:text-[#5173EF] transition"
      [ngClass]="{ 'text-[#5173EF]': currentLang === 'en' }">
      EN
    </button>
  </div>
</div>